<template>
  <transition
    :enter-active-class="transitionEnterClass"
    :leave-active-class="transitionLeaveClass"
    @before-leave="onBeforeLeave"
  >
    <div ref="el" class="form-page" v-if="$route.params.id == $props.id || $props.print">
      <div class="form-page-inner">
        <intro-component :id="$props.id" />
        <form class="standard-form-style">
          <question-collection-component :id="$props.id" />
        </form>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { getCurrentInstance, onMounted, onUnmounted, provide, reactive, ref } from 'vue';
import QualityMentoringForm from '../models/QualityMentoringForm';
import IntroComponent from './IntroComponent.vue';
import QuestionCollectionComponent from './QuestionCollectionComponent.vue';
import Manager from '../../../core/Manager';

const props = defineProps({
  id: Number,
  print: Boolean
})

const transitionEnterClass = ref();
const transitionLeaveClass = ref();
const submission = reactive(Manager.getInstance().submission);
const page = QualityMentoringForm.getInstance().pages[props.id - 1];
const vm = getCurrentInstance();

const activeQuestionIdString = ref();

const updateActiveQuestionIdString = (id) => {
  activeQuestionIdString.value = id;
}

page.setNextUnansweredQuestionIdString(submission);
provide('page', page);
provide('print', props.print);
provide('activeQuestionIdString', {
  activeQuestionIdString,
  updateActiveQuestionIdString
})

const onBeforeLeave = (el) => {
  const cssHeaderHeight = Number(getComputedStyle(document.documentElement).getPropertyValue('--mc-2022-header-height').replace('px', ''));
  const cssSafeInsetTop = Number(getComputedStyle(document.documentElement).getPropertyValue('--safe-inset-top').replace('px', ''));
  const headerHeight = cssHeaderHeight + cssSafeInsetTop;
  const scrollY = window.scrollY;
  const top = scrollY < headerHeight ? scrollY : headerHeight;
  window.scrollTo({ top: top });
  el.style.top = `${-scrollY + top}px`;
};

defineExpose({
  transitionEnterClass,
  transitionLeaveClass
})

const onBeforeUpdatePrompt = () => {
  page.setNextUnansweredQuestionIdString(submission);
  vm.emit('updatePercentageComplete', props.id, page.percentComplete);
}

onMounted(() => {
  if(!props.print) {
    vm.emit('updatePercentageComplete', props.id, page.percentComplete);
    document.body.addEventListener('beforeUpdatePrompt', onBeforeUpdatePrompt);
  }
})

onUnmounted(() => {
  document.body.removeEventListener('beforeUpdatePrompt', onBeforeUpdatePrompt);
});
</script>
